import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { BodenvegetationZeile, hatHumusForm, neueZeilenKennung, hatVegetationsformengruppe, isString, schichtLabel, trackByIndex } from 'src/app/data-model';
import { updateSchichtAnteile } from '../../evaluators/schichtanteil';

@Component({
    standalone: false,
    selector: 'bp-vegetationsaufnahme',
    templateUrl: './vegetationsaufnahme.component.html',
    styleUrls: ['./hl-area.component.css', '../bohrpunkt-boden/bohrpunkt-boden.component.css', './vegetationsaufnahme.component.css'],
    
})
export class VegetationsaufnahmeComponent extends HlAreaComponent {
  trackByIndex = trackByIndex;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	schichtLabel = schichtLabel;
	isString = isString;

  onAddVegetationsZeile() {
    const veg = this.data?.bodenvegetation.aufnahme.vegetationen;
    if (!veg) return;
    const last = veg[veg.length - 1];
    veg.push({ id: neueZeilenKennung(), schicht: last?.schicht } as BodenvegetationZeile);
    this.updateSchichtAnteile();
    this.vs.dirty.next(true);
  }

  onRemoveVegetationsZeile(i: number) {
    this.data?.bodenvegetation.aufnahme.vegetationen.splice(i, 1);
    this.updateSchichtAnteile();
    this.revalidateVegetation();
    this.vs.dirty.next(true);
  }

  onVegetationChanged() {
    this.updateSchichtAnteile();
    this.revalidateVegetation();
  }

  /**
   * Stösst die Dublettenprüfung aller Vegetationszeilen neu an. Nötig, weil das
   * Kriterium (gleiche Art in gleicher Schicht) zeilenübergreifend ist: ändert
   * sich Schicht oder Art einer Zeile, müssen auch die anderen Zeilen neu
   * bewertet werden, nicht nur die gerade bearbeitete.
   */
  private revalidateVegetation() {
    this.vs.revalidate.next('Vegetation');
  }

	private static readonly SCHICHT_ORDER: readonly ('b1'|'b2'|'str'|'kr1'|'kr2'|'m')[] = ['b1', 'b2', 'str', 'kr1', 'kr2', 'm'];

	schichten(): ('b1'|'b2'|'str'|'kr1'|'kr2'|'m')[] {
		const schichten = new Set<'b1'|'b2'|'str'|'kr1'|'kr2'|'m'>();
		this.data.bodenvegetation.aufnahme.vegetationen.forEach((bv: BodenvegetationZeile) => {
			if (bv.schicht) schichten.add(bv.schicht);
		});
		return VegetationsaufnahmeComponent.SCHICHT_ORDER.filter(s => schichten.has(s));
	}

	updateSchichtAnteile() {
		updateSchichtAnteile(this.data);
	}
}
